import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import type { Benefit, BenefitRow } from '@components/pages/SubscribeTest/interfaces';

export const WITH_YOUR_ANNUAL_SUBSCRIPTION_TITLE = 'With Your Annual Subscription';
export const AUDIO_LISTEN_TO_ARTICLES = 'Audio: listen to articles';

export const ANNUAL_BENEFITS: Benefit[] = [
  { label: 'All of our award-winning journalism' },
  {
    label: '8+ newsletters',
    stackedBenefits: true,
    suffix: '(AI deep dives, briefings, and more)',
  },
  { label: 'Charts and data library' },
  { label: 'Daily streaming show', suffix: 'TITV', suffixClassName: 'text-primary-magenta' },
  { label: 'The Information app' },
  { label: AUDIO_LISTEN_TO_ARTICLES },
  { label: 'Community networking tools' },
];

export const PRO_BENEFITS: Benefit[] = [
  {
    Icon: IconDeepResearchText,
    stackedBenefits: true,
    suffix: '(AI-powered search)',
  },
  { label: 'Library of 60+ company org charts' },
  { label: '12 Proprietary databases' },
  { label: 'Subscriber survey results' },
  { blank: true },
  { blank: true },
];

export const APP_IMAGE_URL = 'https://tii.imgix.net/global/subscribe/variant_t/app-image.gif';
export const CHARTS_AND_DATA_LIBRARY_IMAGE_URL =
  'https://tii.imgix.net/global/subscribe/variant_t/charts-and-data-library.jpg';
export const EVENTS_IMAGE_URLS = [
  'https://tii.imgix.net/global/subscribe/variant_t/events_image_1.jpg',
  'https://tii.imgix.net/global/subscribe/variant_t/events_image_2.jpg',
  'https://tii.imgix.net/global/subscribe/variant_t/events_image_3.jpg',
];
export const EXCLUSIVE_REPORTING_IMAGE_URL =
  'https://tii.imgix.net/global/subscribe/variant_t/exclusive_reporting.jpg';
export const NEWSLETTERS_IMAGE_URL =
  'https://tii.imgix.net/global/subscribe/variant_t/newsletter_v2.jpg';
export const PRO_IMAGE_URLS = [
  'https://tii.imgix.net/global/subscribe/variant_t/org_chart.png',
  'https://tii.imgix.net/global/subscribe/variant_t/deep_research_laptop.png',
  'https://tii.imgix.net/global/subscribe/variant_t/data_tools.png',
];

export const BENEFIT_ROWS: BenefitRow[] = [
  {
    title: 'Exclusive Reporting',
    paragraphs: [
      'The Information delivers exclusive reporting on tech, AI and finance, led by expert journalists dedicated to each beat. Our editors—veterans of outlets like The New York Times, The Wall Street Journal, Forbes and Reuters—combine deep industry knowledge with trusted sources to break news ahead of larger competitors.',
    ],
    imageUrl: EXCLUSIVE_REPORTING_IMAGE_URL,
  },
  {
    title: 'Charts and Data Library',
    paragraphs: [
      'Search our full Charts Library for visual data on Big Tech, startups and leading AI players like OpenAI. Quickly distill complex reporting into a clear view of strategy, competition and valuations. Every chart has its own dedicated page—with a link to the original article—so you can easily connect the data to deeper context.',
    ],
    imageUrl: CHARTS_AND_DATA_LIBRARY_IMAGE_URL,
  },
  {
    title: 'Newsletters',
    paragraphs: [
      "Follow the reporters and editors who break and shape the news through The Information's newsletters—your essential guide to the biggest developments in tech and AI, from dealmaking and AI agents to the forces financing the AI boom.",
      'The Briefing | AI Agenda | AI Infrastructure',
    ],
    footnote: '+5 more',
    imageUrl: NEWSLETTERS_IMAGE_URL,
  },
];

export const MAX_YOUTUBE_VIDEO_WIDTH = '750';
